
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-52e0f846\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Category.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Category.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-52e0f846\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Category.vue"),
  /* scopeId */
  "data-v-52e0f846",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/category/Category.vue
// module id = 655
// module chunks = 1